// vendor
import React from "react";

// app
import {
  HeaderSubtitleContainer,
  HeaderContainer,
  HeaderTitle,
  MottoHeaderContainer,
} from "./styled";
import { landingPage } from "../../constants/descriptions";
import HomepageAddressEntry from "../../containers/LandingPage/HomepageAddressEntry";

function LandingPageHeader() {
  return (
    <HeaderContainer
      className="page-header"
      image={require("../../assets/img/background-header.jpg")}
    >
      <div className="filter" />
      <MottoHeaderContainer>
        <div className="motto">
          <HeaderTitle>{landingPage.header.getTitle()}</HeaderTitle>
          <HeaderSubtitleContainer>
            <h3>{landingPage.header.getSubtitle1()}</h3>
            <h3>{landingPage.header.getSubtitle2()}</h3>
            <h3 className="pricing-tagline">{landingPage.header.getSubtitle3()}</h3>
          </HeaderSubtitleContainer>
          <div style={{ maxWidth: 560, margin: "1.5rem auto 0" }}>
            <HomepageAddressEntry
              autosuggestId="homepage-hero-address"
              placeholder="Enter your property address"
            />
          </div>
        </div>
      </MottoHeaderContainer>
    </HeaderContainer>
  );
}

export default LandingPageHeader;
